import { render, staticRenderFns } from "./OnboardingStepContactTypes.vue?vue&type=template&id=4616f5c6&scoped=true&"
import script from "./OnboardingStepContactTypes.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepContactTypes.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStepContactTypes.vue?vue&type=style&index=0&id=4616f5c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4616f5c6",
  null
  
)

export default component.exports